import fecha from 'fecha';
import { EventActions, EventCategories, EventLabels } from '../../constants/Analytics';
import Constants from '../../constants/Articles';

export function getThumborURL(imageUrl, sizeOfImage?: string, type?: string, filter?: string) {
  sizeOfImage = typeof sizeOfImage !== 'undefined' ? sizeOfImage : 'orig';
  type = typeof type !== 'undefined' ? type : 'smart';
  filter = typeof filter !== 'undefined' ? filter : '';

  if (typeof imageUrl === 'string') {
    imageUrl = imageUrl.trim();
  }

  if (imageUrl === '') {
    return imageUrl;
  }

  let filters = '';
  if (filter !== '') {
    filters = `/filters:${filter}`;
  }

  const resource = `${sizeOfImage}/${type}${filters}/${imageUrl}`;
  imageUrl = `${Constants.THUMBNAIL_URL}/unsafe/${resource}`;

  return imageUrl;
}

export const getArticleBreadcrumbs = (data = {} as any) => {
  const hasData = Object.keys(data).length > 0;
  const hasArticle = hasData && Object.keys(data.article).length > 0;
  const hasCategory = hasData && Object.keys(data.category).length !== 0;
  const hasTopic = hasData && Object.keys(data.topic).length !== 0;
  const category = hasData ? data.category : { key: '', name: '' };
  const topic = hasData ? data.topic : { key: '', name: '' };
  const articleName = hasArticle && data.article.title ? data.article.title : '';
  const articleLink = hasArticle && data.article.key ? data.article.key : '';
  const hasArticleName = !!articleName;
  const breadcrumbs = [
    { preqrequisites: [], href: '/', name: 'hipages' },
    {
      preqrequisites: [hasCategory],
      href: `/find/${category.key}`,
      name: category.name
    },
    { preqrequisites: [!hasCategory], href: '/articles', name: 'Articles' },
    {
      preqrequisites: [hasTopic],
      href: `/c/${topic.key}`,
      name: `${topic.name} Articles`
    },
    {
      preqrequisites: [hasArticleName],
      href: articleLink ? `/article/${articleLink}` : null,
      name: articleName
    }
  ];
  const filteredBreadcrumbs = breadcrumbs.filter(
    breadcrumb => !!breadcrumb.name && breadcrumb.preqrequisites.every(condition => !!condition)
  );
  return filteredBreadcrumbs.map(({ href, name }) => {
    const breadcrumb = { name } as any;

    if (href) {
      breadcrumb.href = href.toLowerCase();
    }

    return breadcrumb;
  });
};

export function formatDate(timestamp) {
  try {
    return fecha.format(Date.parse(timestamp), 'MMM D, YYYY');
  } catch (e) {
    return '';
  }
}

export function loadScript(src: any, async?: any, attributes?: any) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const tagName = 'script';
  const script = document.createElement(tagName);
  script.src = src;

  if (async) {
    script.async = true;
  }

  if (attributes) {
    Object.entries(attributes).forEach(([key, value]: [any, any]) => {
      script.setAttribute(key, value);
    });
  }

  const head = document.getElementsByTagName('head')[0];

  head.insertBefore(script, head.childNodes[0]);
}

export const googleTagManager = {
  dataLayerPush: (varName, varValue) => {
    if (typeof window !== 'undefined' && varValue) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      const data = {};
      data[varName] = varValue;
      if ((window as any).dataLayer.indexOf(data) < 0) {
        (window as any).dataLayer.push(data);
      }
    }
  }
};

export const pushDataLayerVariables = dataLayerVariables => {
  for (const [key, value] of Object.entries(dataLayerVariables)) {
    googleTagManager.dataLayerPush(key, value);
  }
};

export function addEnglishArticleWord(str) {
  const vowels = 'aeiou';
  if (vowels.indexOf(str.charAt(0).toLowerCase()) !== -1) {
    return `an ${str}`;
  }
  return `a ${str}`;
}

export const getSourceFromThumborUrl = (thumborUrl = '') => {
  return `https:${thumborUrl.replace(/(http:)|(https:)/g, '%p%').split('%p%')[2]}`;
};

/**
 * Returns a string of get quotes form url
 *
 * @param img DOM img element
 */
export const easeLoad = img => {
  if (img.classList.contains('loaded')) {
    return;
  }

  img.classList.add('loaded');

  const container = document.createElement('div');
  container.style.position = 'relative';
  // put container before img
  img.parentNode.insertBefore(container, img);
  // append img into container
  container.appendChild(img);

  const srcset = img.getAttribute('data-srcset');
  const sizes = img.getAttribute('data-sizes');
  const src = img.getAttribute('data-src');
  img.setAttribute('data-srcset', '');
  img.setAttribute('data-sizes', '');
  img.setAttribute('data-src', '');

  // create cover img
  const coverImg = new Image();
  Object.assign(coverImg.style, {
    width: '100%',
    height: 'auto',
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    transition: '400ms'
  });

  coverImg.onload = () => {
    container.appendChild(coverImg);
    setTimeout(() => (coverImg.style.opacity = '1'), 100);
  };

  coverImg.setAttribute('data-pin-media', getSourceFromThumborUrl(src));
  coverImg.setAttribute('src', src);
  coverImg.setAttribute('srcset', srcset);
  coverImg.setAttribute('sizes', sizes);
};

export const registerPinterestTracking = () => {
  window.addEventListener('click', event => {
    const element = (event.target as Element) || (event.srcElement as Element);

    if (!element.getAttribute('data-pin-log')) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'hipagesInteractiveEvent',
      eventCategory: EventCategories.ARTICLES,
      eventAction: EventActions.PINTEREST_CLICK_SAVE_BUTTON,
      eventLabel: EventLabels.PINTEREST_CLICK_SAVE_BUTTON
    });
  });
};

export function getArticleImageMediaQueriesObject(imageUrl) {
  return {
    xs: getThumborURL(imageUrl, `320x0`),
    sm: getThumborURL(imageUrl, `480x0`),
    md: getThumborURL(imageUrl, `768x0`),
    lg: getThumborURL(imageUrl, `2560x0`)
  };
}

export function ucfirst(str) {
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}
